import { FC } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "@splidejs/react-splide/css";
import { motion } from "framer-motion";

const MakerLogoCarousel: FC = (): JSX.Element => {
  return (
    <motion.div
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      transition={{
        duration: 0.3,
      }}
    >
      <Splide
        options={{
          drag: false,
          type: "loop",
          arrows: false,
          pagination: false,
          autoScroll: {
            pauseOnHover: false,
            pauseOnFocus: false,
            rewind: true,
            speed: 0.5,
          },
          fixedWidth: 80,
          gap: 18,
        }}
        extensions={{ AutoScroll }}
      >
        {[
          { src: "/imgs/maker_lp/maker/logo_ADVAN.jpg", alt: "ADVAN" },
          { src: "/imgs/maker_lp/maker/logo_AICA.png", alt: "AICA" },
          { src: "/imgs/maker_lp/maker/logo_board.png", alt: "board" },
          {
            src: "/imgs/maker_lp/maker/logo_Creation-Baumann.png",
            alt: "Creation-Baumann",
          },
          {
            src: "/imgs/maker_lp/maker/logo_DANTO-TILE.png",
            alt: "ダントータイル",
          },
          {
            src: "/imgs/maker_lp/maker/logo_DINAONE.png",
            alt: "ダイナワン",
          },
          {
            src: "/imgs/maker_lp/maker/logo_HP.png",
            alt: "H&P",
          },
          {
            src: "/imgs/maker_lp/maker/logo_KMEW.png",
            alt: "ケイミュー",
          },
          {
            src: "/imgs/maker_lp/maker/logo_LAMINAM.png",
            alt: "ラミナム",
          },
          {
            src: "/imgs/maker_lp/maker/logo_LIXIL.png",
            alt: "LIXIL",
          },
          {
            src: "/imgs/maker_lp/maker/logo_sangetsu.png",
            alt: "サンゲツ",
          },
          {
            src: "/imgs/maker_lp/maker/logo_shikokukasei.png",
            alt: "四国化成",
          },
          {
            src: "/imgs/maker_lp/maker/logo_tokyokoei.jpg",
            alt: "東京工営",
          },
          {
            src: "/imgs/maker_lp/maker/logo_TOLI.png",
            alt: "東リ",
          },
          {
            src: "/imgs/maker_lp/maker/logo_WHO.png",
            alt: "WHO",
          },
          {
            src: "/imgs/maker_lp/maker/logo_WOODTEC.png",
            alt: "WOODTEC",
          },
        ].map((value) => (
          <SplideSlide className="flex justify-center" key={value.src}>
            <img {...value} className="object-contain" />
          </SplideSlide>
        ))}
      </Splide>
    </motion.div>
  );
};
export default MakerLogoCarousel;
